import React from 'react';
import Dialog from 'material-ui/Dialog';
import {
  PreviewModal,
  TrailExpired,
  TrailExpiredMA,
  MASignupEmail
} from './Modals';

const modalType = Modal => {
  const ModalType = props =>
    (
    <Dialog
      contentStyle={{
        width: props.purpose === 'invite' ? 442 : 535
      }}
      bodyStyle={{
        padding: props.purpose === 'import' ? 0 : 24
      }}
      open={props.open}

    >
      {props.purpose === 'preview' ? (
        <Modal>
          <PreviewModal
            handleClose={props.handleClose}
            fvdomainId={props.fvdomainId}
            emailData={props.emailData}
            changeTemplate={props.changeTemplate}
            isUpdating={props.isUpdating}
            editActivationEmailTemplate={props.editActivationEmailTemplate}
          />
        </Modal>
      ) : props.purpose === 'trailExpired' ? (

        <Modal>
          <TrailExpired
            handleClose={props.handleClose}
            fvdomainId={props.fvdomainId}
            changeTemplate={props.changeTemplate}
            ExpiredUserDefault={props.getExpiredUserDefaultTemplate}
            defaultData={props.defaultData}
            isUpdating={props.isUpdating}
          />
        </Modal>
      ) : props.purpose === 'trailExpiredMA' ? (
        <Modal>
          <TrailExpiredMA
          mauscript
            handleClose={props.handleClose}
            fvdomainId={props.fvdomainId}
            changeTemplate={props.changeTemplate}
            expiredMADefault={props.expiredMADefault}
            maData={props.maData}
            isUpdating={props.isUpdating}
          />
        </Modal>
      ) : props.purpose === 'MASignupEmail' ? (
        <Modal>
          <MASignupEmail
            handleClose={props.handleClose}
            fvdomainId={props.fvdomainId}
            changeTemplate={props.changeTemplate}
            MASignupEmailTemplate={props.MASignupEmailTemplate}
            signupData={props.signupData}
            isUpdating={props.isUpdating}
          />
        </Modal>
      ) :
      "" }
    </Dialog>
  );
  return ModalType;
};

export default modalType;



// WEBPACK FOOTER //
// src/components/Seminars/SeminarActions/ModalHOC.js